
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

var script = {
  name: 'PendoCheckboxCell',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('label', {
    staticClass: "pendo-table__checkbox",
    class: {
      'is-checked': _vm.checked,
      'is-disabled': _vm.disabled,
      'is-indeterminate': _vm.indeterminate
    },
    attrs: {
      "role": "checkbox",
      "aria-disabled": _vm.disabled,
      "aria-checked": _vm.indeterminate ? 'mixed' : _vm.checked
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "pendo-table__checkbox-inner",
    attrs: {
      "d": "M12.67 2H3.33C2.6 2 2 2.6 2 3.33v9.34C2 13.4 2.6 14 3.33 14h9.34c.73 0 1.33-.6 1.33-1.33V3.33C14 2.6 13.4 2 12.67 2z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _vm.indeterminate ? _c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M10 7H6a1 1 0 000 2h4a1 1 0 100-2z"
    }
  }) : _vm._e(), _vm._v(" "), _vm.checked ? _c('path', {
    attrs: {
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "d": "M10.67 6L7 9.67 5.33 8"
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', _vm._g({
    attrs: {
      "type": "checkbox",
      "name": "checkbox",
      "aria-hidden": "true",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.checked
    }
  }, _vm.$listeners))]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-checkbox-cell.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var Checkbox = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default Checkbox;
